export default {"src":"/_next/static/media/double-checkmark.d0993e05.gif","height":500,"width":500,"blurWidth":0,"blurHeight":0};